import jwt_decode from 'jwt-decode';
import { getLocalImpersonationUserId } from './localImpersonation';

const addImpersonationHeader = (headers) => {
    const impersonationUserId = getLocalImpersonationUserId();
    if (impersonationUserId) {
        headers['x-impersonate-user-id'] = impersonationUserId;
    }
    return headers;
};

const getAccessToken = () => localStorage.getItem('token');
const getRefreshToken = () => localStorage.getItem('refreshToken');

const getTokenState = (token) => {
    if (!token) return 'missing';

    try {
        const payload = jwt_decode(token);
        return payload.exp * 1000 < new Date().getTime() ? 'expired' : 'valid';
    } catch (error) {
        console.warn('Invalid token in auth headers:', error.message);
        return 'invalid';
    }
};

export const getGraphqlAuthHeaders = () => {
    const token = getAccessToken();
    const tokenState = getTokenState(token);

    if (tokenState === 'expired') {
            const headers = {
                'x-token': token
            };
            const refreshToken = getRefreshToken();
            if (refreshToken) headers['x-refresh-token'] = refreshToken;
            return addImpersonationHeader(headers);
    }

    if (tokenState === 'valid') {
        return addImpersonationHeader({
            'x-token': token
        });
    }

    return addImpersonationHeader({
        'x-token': null
    });
};

export const getAuthHeaders = ({ includeRefreshToken = false, contentType } = {}) => {
    const headers = {};

    if (contentType) {
        headers['Content-Type'] = contentType;
    }

    const token = getAccessToken();
    if (token || token === null) {
        headers['x-token'] = token;
    }

    if (includeRefreshToken) {
        const refreshToken = getRefreshToken();
        if (refreshToken) {
            headers['x-refresh-token'] = refreshToken;
        }
    }

    return addImpersonationHeader(headers);
};

export const getSubscriptionConnectionParams = () => {
    return addImpersonationHeader({
        'x-token': getAccessToken()
    });
};
